import styled from 'styled-components';
import { abstractBackgroundSoft } from './BackgroundPatterns';
import { techColors, neonGlow, terminalBorder, textGlowStrong, terminalTextStyle, terminalHeaderStyle } from './TechRetroEffects';

export const ForgotPasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  ${abstractBackgroundSoft}
  color: ${techColors.textPrimary};
  text-align: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
  ${terminalTextStyle}


  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const Title = styled.h1`
  font-size: 3em;
  color: ${techColors.neonCyan};
  margin-bottom: 0.5em;
  margin-top: -0.3em;
  letter-spacing: 0.02em;
  position: relative;
  display: inline-block;
  ${textGlowStrong(techColors.neonCyan)}
  ${terminalHeaderStyle}

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: ${techColors.neonCyan};
    box-shadow: 0 0 10px ${techColors.neonCyan};
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2.2em;
    margin-top: -0.2em;
    
    &::after {
      width: 50px;
      height: 2px;
      bottom: -6px;
    }
  }

  @media (max-width: 480px) {
    font-size: 1.8em;
    margin-bottom: 0.3em;
    margin-top: 0;
    letter-spacing: 0.01em;
    
    &::after {
      width: 40px;
      height: 2px;
      bottom: -4px;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 360px;
  background-color: ${techColors.darkBgSecondary};
  ${terminalBorder(techColors.neonCyan)}
  padding: 28px 24px;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    ${neonGlow(techColors.neonCyan, 'subtle')}
  }

  @media (max-width: 768px) {
    padding: 24px 20px;
    max-width: 340px;
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
    max-width: 100%;
    border-radius: 10px;
  }
`;

export const Input = styled.input`
  padding: 8px 12px;
  margin: 0 0 10px 0;
  ${terminalBorder(techColors.neonCyan)}
  border-radius: 4px;
  width: 100%;
  max-width: ${({ $narrow }) => $narrow ? '200px' : '320px'};
  font-size: 0.9em;
  text-align: center;
  background-color: ${techColors.darkBg};
  color: ${techColors.textPrimary};
  transition: all 0.3s ease;
  ${terminalTextStyle}

  &:focus {
    outline: none;
    ${neonGlow(techColors.neonCyan, 'strong')}
    border-color: ${techColors.neonCyan};
    background-color: ${techColors.darkBg};
    transform: translateY(-1px);
  }

  &::placeholder {
    color: ${techColors.textSecondary};
    opacity: 0.6;
    text-align: center;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: 0.85em;
    padding: 7px 11px;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    font-size: 0.8em;
    padding: 6px 10px;
    margin-bottom: 10px;
  }
`;

export const Button = styled.button`
  color: ${techColors.neonCyan};
  text-decoration: none;
  font-size: 1em;
  font-weight: 600;
  padding: 12px 36px;
  ${terminalBorder(techColors.neonCyan)}
  border-radius: 4px;
  background: ${techColors.darkBgTertiary};
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 16px;
  letter-spacing: 0.5px;
  ${terminalHeaderStyle}
  width: 100%;
  max-width: 320px;
  
  &:hover {
    ${neonGlow(techColors.neonCyan, 'strong')}
    background: ${techColors.darkBg};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    font-size: 0.95em;
    padding: 10px 32px;
  }

  @media (max-width: 480px) {
    padding: 10px 28px;
    font-size: 0.9em;
    margin-top: 12px;
  }
`;

export { AuthPageMessage as Message } from './StatusMessageStyles';

export const CountdownText = styled.p`
  margin-top: 16px;
  font-size: 0.9em;
  color: ${techColors.textSecondary};
  text-align: center;
  ${terminalTextStyle}
`;

export const ResendButton = styled.button`
  color: ${techColors.neonCyan};
  background: ${techColors.darkBgTertiary};
  ${terminalBorder(techColors.neonCyan)}
  border-radius: 4px;
  padding: 10px 24px;
  font-size: 0.9em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 380px;
  letter-spacing: normal;
  ${terminalTextStyle}

  &:hover:not(:disabled) {
    ${neonGlow(techColors.neonCyan, 'strong')}
    background: ${techColors.darkBg};
    color: ${techColors.neonCyan};
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: ${techColors.textSecondary};
    color: ${techColors.textSecondary};
  }

  @media (max-width: 480px) {
    font-size: 0.85em;
    padding: 8px 20px;
  }
`;
